import { resetOpenedDropdowns } from '@atoms/dropdown-menu';
import { flashbags } from './header/flashbags';

export const header = () => {
  if (document.querySelector('#flashbags')) {
    flashbags();
  }

  const dropdown = document.querySelector('.location-dropdown-container');
  const button = document.querySelector('.location-dropdown--button');

  if (!dropdown || !button) {
    return;
  }

  const toggleDropdown = (event) => {
    event.stopPropagation();
    const isOpen = dropdown.classList.toggle('show');
    button.classList.toggle('open', isOpen);

    resetOpenedDropdowns();
  };

  button.addEventListener('click', toggleDropdown);

  document.addEventListener('click', (event) => {
    if (!dropdown.contains(event.target) && !button.contains(event.target)) {
      dropdown.classList.remove('show');
      button.classList.remove('open');
    }
  });
};
